import * as React from "react";
import styled from "styled-components";
import { LinkContainer } from "components/common/router";
import { Badge, Nav } from "components/bootstrap";
import Routes from "routing/Routes";
import { NAV_ITEM_HEIGHT } from "theme/constants";
import useNotifications from "components/notifications/useNotifications";
import InactiveNavItem from "./InactiveNavItem";
const StyledNav = styled(Nav)`
  > li > a {
    min-height: ${NAV_ITEM_HEIGHT};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
  }
`;
const StyledInactiveNavItem = styled(InactiveNavItem)`
  a:hover {
    border: 0;
    text-decoration: none;
  }
`;
const NotificationBadge = () => {
  const { data, isLoading } = useNotifications();
  return isLoading || data.total === 0 ? null : /* @__PURE__ */ React.createElement(StyledNav, { navbar: true }, /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.SYSTEM.OVERVIEW }, /* @__PURE__ */ React.createElement(StyledInactiveNavItem, null, /* @__PURE__ */ React.createElement(Badge, { bsStyle: "danger", "data-testid": "notification-badge", title: "System Notifications" }, data.total))));
};
export default NotificationBadge;
